import { c as _c } from "react/compiler-runtime";
import { StatsigProvider, type StatsigUser, useClientAsyncInit } from '@statsig/react-bindings';

/**
 * These properties are set when app is fully loaded for a logged-in user.
 */
interface User extends StatsigUser {
  custom?: {
    clientId: number;
    clientName: string;
  };
  privateAttributes?: {
    email: string;
  };
}
export const FeatureFlagProvider = t0 => {
  const $ = _c(5);
  const {
    children,
    user: t1,
    platformKey
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const user = t2;
  const {
    client
  } = useClientAsyncInit(platformKey, user);
  let t3;
  if ($[2] !== children || $[3] !== client) {
    t3 = <StatsigProvider client={client}>{children}</StatsigProvider>;
    $[2] = children;
    $[3] = client;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  return t3;
};